export default __webpack_public_path__ + "static/media/HammadAli_CV.3191faf1.pdf";